var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-announcement-card"},[_c('div',{staticClass:"r-isFlex r-announcement-card-img"},[_c('div',{staticClass:"r-isExpand r-skeleton"})]),_c('h5',{staticClass:"r-mb-10 r-skeleton"}),_c('p',{staticClass:"r-mt-auto r-skeleton"})])
}]

export { render, staticRenderFns }